import { iframeResizerChild } from './lib/iframeResizerChild'

iframeResizerChild()

export * from './lib/iframeResizerChild'
